import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

import type { ThemeCustomComponent } from '../../types';
import type { InlineMessageProps } from './types';

declare module '@mui/material/styles' {
  interface ComponentsPropsList {
    InlineMessage: InlineMessageProps;
  }

  interface ComponentNameToClassKey {
    InlineMessage: keyof typeof inlineMessageClasses;
  }

  interface Components {
    InlineMessage?: ThemeCustomComponent<'InlineMessage'>;
  }
}

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('InlineMessage', slot);
}

export const inlineMessageClasses = generateUtilityClasses('InlineMessage', [
  'root',
  'icon',
  'message',
]);
